import React from 'react';

interface CalendarIconProps {
  isActive?: boolean;
  className?: string;
}

const CalendarIcon: React.FC<CalendarIconProps> = ({ isActive = false, className = 'mr-2' }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    className={className} 
    width="18" 
    height="18" 
    viewBox="0 0 24 24" 
    fill="none" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <rect 
      width="18" 
      height="18" 
      x="3" 
      y="4" 
      rx="2" 
      ry="2" 
      stroke={isActive ? "#4F46E5" : "#4B5563"}
      fill="#EEF2FF"
    />
    <line x1="16" x2="16" y1="2" y2="6" stroke={isActive ? "#4F46E5" : "#4B5563"} />
    <line x1="8" x2="8" y1="2" y2="6" stroke={isActive ? "#4F46E5" : "#4B5563"} />
    <line x1="3" x2="21" y1="10" y2="10" stroke={isActive ? "#4F46E5" : "#4B5563"} />
    <path d="M8 14h.01" stroke="#FF6B6B" strokeWidth="3" />
    <path d="M12 14h.01" stroke="#FF6B6B" strokeWidth="3" />
    <path d="M16 14h.01" stroke="#FF6B6B" strokeWidth="3" />
    <path d="M8 18h.01" stroke="#FF6B6B" strokeWidth="3" />
    <path d="M12 18h.01" stroke="#FF6B6B" strokeWidth="3" />
    <path d="M16 18h.01" stroke="#FF6B6B" strokeWidth="3" />
  </svg>
);

export default CalendarIcon;
